import React, {PropTypes} from 'react';
import FormInput from './forminput.react';

export default class NumericInput extends FormInput {
  static propTypes = {
    action: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    title: PropTypes.string,
    inputTitle: PropTypes.string,
    pattern: PropTypes.string,
    required: PropTypes.bool,
    value: PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.number
    ]),
    onBlur: PropTypes.func,
    onFocus: PropTypes.func
  }

  onChange(event) {
    const {target: {name, value}} = event;
    const {action} = this.props;
    const v = parseInt(value, 10);

    action({target: {name, value: isNaN(v) ? 0 : v}});
  }

  render() {
    const {
      name,
      title,
      inputTitle,
      pattern,
      required,
      value
    } = this.props;
    return (
      <div className="form-group">
        {title && <label>{title}</label> }
        <input
          className="form-control"
          name={name}
          title={inputTitle}
          required={required}
          onChange={::this.onChange}
          onBlur={::this.onInputBlur}
          onFocus={::this.onInputFocus}
          pattern={pattern}
        type="number" value={value} min="0"/>
      </div>
    );
  }
}
